export { default } from './svg/image.svg';
